import { apiClient } from "@/lib/api/client";
import type { MockBillingResponse } from "@/lib/api/types";

export async function getBillingOverview(): Promise<MockBillingResponse> {
  const { data } = await apiClient.get<MockBillingResponse>("/billing");
  return data;
}
